export default {
    configuration: true,
    'buttonList': [
        {
            'type': 'text',
            'icon': 'el-icon-search',
            'label': '刷新',
            'size': 'small',
            'event': 'refresh',
        },
        {
            'type': 'text',
            'icon': 'el-icon-search',
            'label': '查询',
            'size': 'small',
            'event': 'search'
        },
        {
            'type': 'text',
            'icon': 'el-icon-circle-plus-outline',
            'label': '新增',
            'size': 'small',
            'event': 'add'
        },
        {
            'type': 'text',
            'icon': 'el-icon-delete',
            'label': '删除',
            'size': 'small',
            'event': 'delete1'
        },
        {
            'type': 'text',
            'icon': 'el-icon-s-check',
            'label': '零担自营线路审批',
            'size': 'small',
            'event': 'approve',
        },
    ],
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'height': 'calc(100vh - 215px)',
        // 'statesY': '启用',
        // 'statesN': '停用',
        'columns': [
            {
                'label': '线路编码',
                'prop': 'routeNo',
                'width': '140px'
            },
            {
                'label': '线路名称',
                'prop': 'routeName',
                'width': '120px'
            },
            {
                'label': '始发地-省份',
                'prop': 'originProvName',
                'width': '120px'
            },
            {
                'label': '始发地-城市',
                'prop': 'originCityName',
                'width': '120px'
            },
            {
                'label': '始发地-区县',
                'prop': 'originCountyName',
                'width': '120px'
            },
            {
                'label': '目的地-省份',
                'prop': 'destinationProvName',
                'width': '120px'
            },
            {
                'label': '目的地-城市',
                'prop': 'destinationCityName',
                'width': '120px'
            },
            {
                'label': '目的地-区县',
                'prop': 'destinationCountyName',
                'width': '120px'
            },
            {
                'label': '审批状态',
                'prop': 'approvalStatus_',
                'width': '120px'
            },
            {
                'label': '审批通过类型',
                'prop': 'approvalType_',
                'width': '120px'
            },
            {
                'label': '是否零担自营线路',
                'prop': 'isSelfManage_',
                'width': '140px'
            },
            {
                'label': '始发地货站',
                'prop': 'originStationName',
                'width': '120px'
            },
            {
                'label': '目的地货站',
                'prop': 'destinationStationName',
                'width': '120px'
            },
            {
                'label': '主发车型',
                'prop': 'carType_',
                'width': '120px'
            },
            {
                'label': '是否有家电运输经验',
                'prop': 'homeTransExp_',
                'width': '160px'
            },
            {
                'label': '自有车数量',
                'prop': 'carNum',
                'width': '110px'
            },
            {
                'label': '主要行业',
                'prop': 'industryType_',
                'width': '110px'
            },
            {
                'label': '主要客户',
                'prop': 'customer',
                'width': '110px'
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': '100px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '更新人',
                'prop': 'updateUserName',
                'width': '100px'
            },
            {
                'label': '更新时间',
                'prop': 'updateTime',
                'width': '150px'
            }
        ],
        'action':
            [
                {
                    'type': 'text',
                    'label': '编辑',
                    'size': 'mini',
                    'event': 'edit'
                },
                {
                    'type': 'text',
                    'label': '审批记录',
                    'size': 'mini',
                    'event': 'record',
                },
            ],
        'leftOperation': true,
        'leftWidth': 160
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
